import React from 'react';
import styled from 'styled-components/macro';

const FormWrapNoStyle = ({
  children,
  HentInfo,
  ...otherProps
}) => (
  <button type="button" {...otherProps}>
    {children}
  </button>
);
export default styled(FormWrapNoStyle)`
  background: ${({ theme }) => theme.colors.colorBlue};
  color: ${({ theme }) => theme.colors.colorWhite};
  outline: none;
  border: 0;
  padding: 2px;
  display: block;

  &:hover {
    background: ${({ theme }) => theme.hoverColors.colorBlue};
  }
`;
